/**
 * Instantanés de soldes (historique pour courbes d'évolution).
 * Distinct des points d'ancrage (calcul du solde courant).
 */

import { supabase } from '../supabaseClient';

export interface SnapshotSoldesResult {
  date: string;
  total_comptes: number;
  inserted: number;
  updated: number;
  unchanged: number;
  existing: number;
  already_exists: boolean;
  no_change: boolean;
  nothing_to_save: boolean;
}

export interface HistoriqueSoldePoint {
  id: string;
  compte_id: string;
  compte_nom: string;
  date_snapshot: string;
  solde: number;
  currency: string;
  created_at: string;
}

function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

export async function hasHistoriqueSoldesAujourdhui(): Promise<{
  data: boolean;
  error: any;
}> {
  try {
    const { data, error } = await supabase.rpc('has_historique_soldes', {
      p_date: todayISO(),
    });
    if (error) return { data: false, error };
    return { data: data === true, error: null };
  } catch (error) {
    return { data: false, error };
  }
}

export async function snapshotMesSoldes(date?: string): Promise<{
  data: SnapshotSoldesResult | null;
  error: any;
}> {
  try {
    const { data, error } = await supabase.rpc('snapshot_mes_soldes', {
      p_date: date || todayISO(),
    });
    if (error) return { data: null, error };
    const row = (data || {}) as SnapshotSoldesResult;
    return {
      data: {
        date: String(row.date || date || todayISO()),
        total_comptes: Number(row.total_comptes || 0),
        inserted: Number(row.inserted || 0),
        updated: Number(row.updated || 0),
        unchanged: Number(row.unchanged || 0),
        existing: Number(row.existing || 0),
        already_exists: row.already_exists === true,
        no_change: row.no_change === true,
        nothing_to_save: row.nothing_to_save === true,
      },
      error: null,
    };
  } catch (error) {
    return { data: null, error };
  }
}

/** Pour de futures courbes d'évolution des soldes. */
export async function getHistoriqueSoldes(opts?: {
  from?: string;
  to?: string;
  compteId?: string;
}): Promise<{ data: HistoriqueSoldePoint[]; error: any }> {
  try {
    const { data, error } = await supabase.rpc('get_historique_soldes', {
      p_from: opts?.from || undefined,
      p_to: opts?.to || undefined,
      p_compte_id: opts?.compteId || null,
    });
    if (error) return { data: [], error };
    const rows = (data as any[]) || [];
    return {
      data: rows.map((r) => ({
        id: r.id,
        compte_id: r.compte_id,
        compte_nom: r.compte_nom,
        date_snapshot: r.date_snapshot,
        solde: Number(r.solde ?? 0),
        currency: r.currency || 'EUR',
        created_at: r.created_at,
      })),
      error: null,
    };
  } catch (error) {
    return { data: [], error };
  }
}
